<template>
  <div>403 Access Denied</div>
</template>

<script>
  export default {
    name: 'FourOThree',
  };
</script>

<style scoped>
  div {
    font-size: 30px;
  }
</style>
